/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IROs } from '../../../shared/services/api/estoque/Relatorios/RelatoriosService';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function ROs(data: IROs[], texto: string) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }
  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [48, 800],
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                width: 800,
                border: [false, false, false, false],
                table: {
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                    [
                      { text: 'Relatório de Ordem de Serviços', margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
                    ],
                  ]
                }
              }
            ],
          ]
        }
      },
      { text: texto, fontSize: 10, alignment: 'left' },
      await Promise.all(
        data.flatMap(async (e) => {
          const { itens } = e;
          const imageData1 = await getBase64ImageFromUrl(e.fotos === null ? process.env.REACT_APP_URL_IMGLOG || '' : process.env.REACT_APP_URL_IMGPATRIMONIO + e.fotos.imgPath || '');
          const rows = itens.map((rowos) => {
            return [
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowos.qtdsaida),
                alignment: 'right', fontSize: 8, border: [false, true, true, true],
              },
              { text: rowos.descricao, alignment: 'left', fontSize: 7 },
              { text: rowos.un, alignment: 'center', fontSize: 7, border: [true, false, false, true], },
            ];
          });
          return [
            [
              [
                {
                  table: {
                    widths: [100, 437],
                    body: [
                      [
                        {
                          image: imageData1, width: 70,
                          border: [true, true, true, false],
                          height: 70,
                          alignment: 'center'
                        },
                        {
                          margin: [-4, -3, 0, -3],
                          table: {
                            widths: [50, 90, 220, 50],
                            body: [
                              [
                                {
                                  text: `${e.numeropat} -  ${e.descricao}  ${e.modelo} ${e.ano}`, fontSize: 12, bold: true,
                                  alignment: 'left', colSpan: 4,
                                  border: [false, false, false, true],
                                },
                                { text: '', fontSize: 8, alignment: 'left' },
                                { text: '', fontSize: 8, alignment: 'left' },
                                { text: '', fontSize: 8, alignment: 'left' },
                              ],
                              [
                                { text: 'Os', fontSize: 8, alignment: 'left', border: [false, false, false, false], },
                                { text: 'Abertura', alignment: 'center', fontSize: 8, border: [false, false, false, false], },
                                { text: 'Status', fontSize: 8, alignment: 'left', border: [false, false, false, false], },
                                { text: (e.status ? 'Fechamento' : ''), alignment: 'center', fontSize: 8, border: [false, false, false, false], },
                              ],
                              [
                                { text: e.numero, fontSize: 8, alignment: 'left', border: [false, false, false, true], },
                                { text: moment(e.dataabertura).format('DD/MM/YYYY'), alignment: 'center', fontSize: 7, border: [false, false, false, true], },
                                { text: e.situacao, fontSize: 8, alignment: 'left', border: [false, false, false, true], },
                                {
                                  text: (e.status ? moment(e.datafechamento).format('DD/MM/YYYY') : ''), alignment: 'center',
                                  border: [false, false, false, true], fontSize: 7
                                },
                              ],
                              [
                                { text: 'Mecanico', fontSize: 8, alignment: 'left', border: [false, false, false, false], colSpan: 2 },
                                { text: '', alignment: 'center', fontSize: 8, border: [false, false, false, false], },
                                { text: 'Operador', fontSize: 8, alignment: 'left', border: [false, false, false, false], colSpan: 2 },
                                { text: '', fontSize: 8, alignment: 'left', border: [false, false, false, false], },
                              ],
                              [
                                { text: e.mecanico, fontSize: 8, alignment: 'left', border: [false, false, false, false], colSpan: 2 },
                                { text: '', alignment: 'center', fontSize: 7, border: [false, false, false, false], },
                                { text: e.operador, fontSize: 8, alignment: 'left', border: [false, false, false, false], colSpan: 2 },
                                {
                                  text: '', alignment: 'center',
                                  border: [false, false, false, false], fontSize: 7
                                },
                              ]
                            ]
                          },
                          border: [true, true, true, false]
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [269, 268],
                    body: [
                      [
                        {
                          text: 'Defeito Reclamado', color: '#ffffff', fontSize: 7, fillColor: '#151717',
                          alignment: 'left', border: [true, false, true, true],
                        },
                        {
                          text: 'Defeito Constatado', fontSize: 7, fillColor: '#151717',
                          alignment: 'left', color: '#ffffff', border: [true, false, true, true],
                        },
                      ],
                      [
                        { text: e.defeitoreclamado, fontSize: 7, alignment: 'left', border: [true, false, true, false], },
                        { text: e.defeitoconstatado, fontSize: 7, alignment: 'left', border: [true, false, true, false], },
                      ],
                    ]
                  },
                },
                {
                  margin: [0, 0, 0, 3],
                  table: {
                    widths: [269, 268],
                    body: [
                      [
                        { text: 'Serviços Realizado', fontSize: 7, fillColor: '#151717', color: '#ffffff', alignment: 'left' },
                        { text: 'Peças Utilizadas', fontSize: 7, fillColor: '#151717', color: '#ffffff', alignment: 'center' },
                      ],
                      [
                        { text: e.servicosrealizados, fontSize: 7, alignment: 'left' },
                        {
                          table: {
                            widths: [38, 196, 15],
                            margin: [0, 0, 0, 3],
                            body: [
                              [
                                { text: 'Quantidade', border: [false, false, true, true], alignment: 'right', fillColor: '#dddddd', fontSize: 7 },
                                { text: 'Descrição', border: [true, false, true, true], alignment: 'center', fillColor: '#dddddd', fontSize: 7 },
                                { text: 'UN', border: [true, false, false, true], alignment: 'center', fillColor: '#dddddd', fontSize: 7 },
                              ],
                              ...rows,
                            ]
                          },
                          alignment: 'left',
                          margin: [-4, -3, 0, -3],
                        },

                      ],
                    ]
                  },
                },
              ]
            ]

          ];
        })
      ),
    ]
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}

export default ROs;


